"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dutchiePayReasonCodes = exports.getDutchiePayErrorMessage = exports.dutchiePayErrors = exports.getDefaultDutchiePayError = void 0;
var get_message_1 = require("./get-message");
var constants_1 = require("./constants");
var supportLink = " Please have customer contact [Dutchie Support](https://help.dutchie.com/hc/en-us/articles/360056774533-Contact-Dutchie-Support)";
var velocityTransactionLimitsLink = "You can learn more about why here: [Dutchie Pay Transaction Limits](https://support.dutchie.com/hc/en-us/articles/13230474205843-What-limits-apply-to-consumer-spending-using-Dutchie-Pay)";
var velocitySpendLimitsLink = "You can learn more about why here: [Dutchie Pay Spend Limits](https://support.dutchie.com/hc/en-us/articles/13230474205843-What-limits-apply-to-consumer-spending-using-Dutchie-Pay)";
var getDefaultDutchiePayError = function (name) {
    if (name === void 0) { name = "Dutchie Pay"; }
    return "".concat(name, " is unavailable. Please use a different method of payment.");
};
exports.getDefaultDutchiePayError = getDefaultDutchiePayError;
// SOURCE: https://dutchie.atlassian.net/wiki/spaces/EN/pages/20067156195/Dutchie+Pay+Reason+Codes
var dutchiePayErrors = function (name) {
    if (name === void 0) { name = "Dutchie Pay"; }
    return new Map([
        [
            'B100',
            {
                source: constants_1.SOURCES.SIFT,
                ecomm: "Customer has exceeded spending limit. ".concat(supportLink),
                pos: "Customer has exceeded spending limit. ".concat(supportLink),
            },
        ],
        [
            'B104',
            {
                source: constants_1.SOURCES.PLAID,
                ecomm: 'Your bank account has insufficient funds to complete this transaction. Please either use a different method of payment or add funds to your bank account and try again',
                pos: 'Your bank account has insufficient funds to complete this transaction. Please either use a different method of payment or add funds to your bank account and try again',
            },
        ],
        [
            'B105',
            {
                source: constants_1.SOURCES.AGGREGATOR,
                ecomm: 'Your bank account is unlinked. Please reconnect with your financial institution.',
                pos: 'Your bank account is unlinked. Please reconnect with your financial institution.',
            },
        ],
        [
            'B106',
            {
                source: constants_1.SOURCES.DUTCHIE_PAY,
                ecomm: "Plaid unable to check bank account balance. Please try again.",
                pos: "Plaid unable to check bank account balance. Please try again.",
            },
        ],
        [
            'E001',
            {
                source: constants_1.SOURCES.DUTCHIE_PAY,
                ecomm: "Your financial institution is not supported by ".concat(name, " at this time. Please use a different method of payment."),
                pos: "Your financial institution is not supported by ".concat(name, " at this time. Please use a different method of payment."),
            },
        ],
        [
            'E002',
            {
                source: constants_1.SOURCES.DUTCHIE_PAY,
                ecomm: "Only checking or savings accounts can be used with ".concat(name, ". Please update your account information and try again."),
                pos: "Only checking or savings accounts can be used with ".concat(name, ". Please update your account information and try again."),
            },
        ],
        [
            'E003',
            {
                source: constants_1.SOURCES.DUTCHIE_PAY,
                ecomm: 'The currency of this account is unsupported. Please connect to an account that uses either USD or CAD for a currency.',
                pos: 'The currency of this account is unsupported. Please connect to an account that uses either USD or CAD for a currency.',
            },
        ],
        [
            'E004',
            {
                source: constants_1.SOURCES.DUTCHIE_PAY,
                ecomm: 'This bank account is already linked to a Dutchie Account. Please link a different bank account.',
                pos: 'This bank account is already linked to a Dutchie Account. Please link a different bank account.',
            },
        ],
        [
            'E005',
            {
                source: constants_1.SOURCES.DUTCHIE_PAY,
                ecomm: 'Order amount must be greater than 0. Please try again.',
                pos: 'Order amount must be greater than 0. Please try again.',
            },
        ],
        [
            'E999',
            {
                source: constants_1.SOURCES.DUTCHIE_PAY,
                ecomm: (0, exports.getDefaultDutchiePayError)(name),
                pos: (0, exports.getDefaultDutchiePayError)(name),
            },
        ],
        [
            'F090',
            {
                source: constants_1.SOURCES.SIFT,
                ecomm: "".concat(name, " account is temporarily blocked. ").concat(supportLink),
                pos: "".concat(name, " account is temporarily blocked. ").concat(supportLink),
            },
        ],
        [
            'F091',
            {
                source: constants_1.SOURCES.DUTCHIE_PAY,
                ecomm: "".concat(name, " account is temporarily blocked. ").concat(supportLink),
                pos: "".concat(name, " account is temporarily blocked. ").concat(supportLink),
            },
        ],
        [
            'F092',
            {
                source: constants_1.SOURCES.SIFT,
                ecomm: "Customer has exceeded transaction limit. ".concat(supportLink),
                pos: "Customer has exceeded transaction limit. ".concat(supportLink),
            },
        ],
        [
            'F093',
            {
                source: constants_1.SOURCES.DUTCHIE_PAY,
                ecomm: "".concat(name, " account is temporarily blocked. ").concat(supportLink),
                pos: "".concat(name, " account is temporarily blocked. ").concat(supportLink),
            },
        ],
        [
            'F094',
            {
                source: constants_1.SOURCES.SIFT,
                ecomm: "".concat(name, " account is temporarily blocked. ").concat(supportLink),
                pos: "".concat(name, " account is temporarily blocked. ").concat(supportLink),
            },
        ],
        [
            'F095',
            {
                source: constants_1.SOURCES.SIFT,
                ecomm: "Customer has unpaid orders. ".concat(supportLink),
                pos: "Customer has unpaid orders. ".concat(supportLink),
            },
        ],
        [
            'F096',
            {
                source: constants_1.SOURCES.SIFT,
                ecomm: "Customer has unpaid orders. ".concat(supportLink),
                pos: "Customer has unpaid orders. ".concat(supportLink),
            },
        ],
        [
            'F098',
            {
                source: constants_1.SOURCES.SIFT,
                ecomm: "DutchiePay account is temporarily blocked. ".concat(supportLink),
                pos: "DutchiePay account is temporarily blocked. ".concat(supportLink),
            },
        ],
        [
            'F099',
            {
                source: constants_1.SOURCES.SIFT,
                ecomm: "DutchiePay account is temporarily blocked. ".concat(supportLink),
                pos: "DutchiePay account is temporarily blocked. ".concat(supportLink),
            },
        ],
        [
            'F100',
            {
                source: constants_1.SOURCES.SIFT,
                ecomm: "Customer has exceeded transaction limit. ".concat(supportLink),
                pos: "Customer has exceeded transaction limit. ".concat(supportLink),
            },
        ],
        [
            'F101',
            {
                source: constants_1.SOURCES.SIFT,
                ecomm: "".concat(name, " account is temporarily blocked. ").concat(supportLink),
                pos: "".concat(name, " account is temporarily blocked. ").concat(supportLink),
            },
        ],
        [
            'F102',
            {
                source: constants_1.SOURCES.SIFT,
                ecomm: "Your financial institution is not supported by ".concat(name, " at this time. Please use a different method of payment."),
                pos: "Your financial institution is not supported by ".concat(name, " Pay at this time. Please use a different method of payment."),
            },
        ],
        [
            'S001',
            {
                source: constants_1.SOURCES.MX,
                ecomm: (0, exports.getDefaultDutchiePayError)(name),
                pos: (0, exports.getDefaultDutchiePayError)(name),
            },
        ],
        [
            'S002',
            {
                source: constants_1.SOURCES.SIFT,
                ecomm: (0, exports.getDefaultDutchiePayError)(name),
                pos: (0, exports.getDefaultDutchiePayError)(name),
            },
        ],
        [
            'S003',
            {
                source: constants_1.SOURCES.DUTCHIE_PAY,
                ecomm: (0, exports.getDefaultDutchiePayError)(name),
                pos: (0, exports.getDefaultDutchiePayError)(name),
            },
        ],
        [
            'S010',
            {
                source: constants_1.SOURCES.DUTCHIE_PAY,
                ecomm: (0, exports.getDefaultDutchiePayError)(name),
                pos: (0, exports.getDefaultDutchiePayError)(name),
            },
        ],
        [
            'V001',
            {
                source: constants_1.SOURCES.CONSUMER_VELOCITY_CHECK,
                ecomm: "Customer has exceeded transaction limit. ".concat(velocityTransactionLimitsLink),
                pos: "Customer has exceeded transaction limit. ".concat(velocityTransactionLimitsLink),
            },
        ],
        [
            'V002',
            {
                source: constants_1.SOURCES.CONSUMER_VELOCITY_CHECK,
                ecomm: "Customer has exceeded transaction limit. ".concat(velocityTransactionLimitsLink),
                pos: "Customer has exceeded transaction limit. ".concat(velocityTransactionLimitsLink),
            },
        ],
        [
            'V003',
            {
                source: constants_1.SOURCES.CONSUMER_VELOCITY_CHECK,
                ecomm: "Customer has exceeded transaction limit. ".concat(velocityTransactionLimitsLink),
                pos: "Customer has exceeded transaction limit. ".concat(velocityTransactionLimitsLink),
            },
        ],
        [
            'V004',
            {
                source: constants_1.SOURCES.CONSUMER_VELOCITY_CHECK,
                ecomm: "Customer has exceeded spending limit. ".concat(velocitySpendLimitsLink),
                pos: "Customer has exceeded spending limit. ".concat(velocitySpendLimitsLink),
            },
        ],
        [
            'V005',
            {
                source: constants_1.SOURCES.CONSUMER_VELOCITY_CHECK,
                ecomm: "Customer has exceeded spending limit. ".concat(velocitySpendLimitsLink),
                pos: "Customer has exceeded spending limit. ".concat(velocitySpendLimitsLink),
            },
        ],
        [
            'V006',
            {
                source: constants_1.SOURCES.CONSUMER_VELOCITY_CHECK,
                ecomm: "Customer has exceeded spending limit. ".concat(velocitySpendLimitsLink),
                pos: "Customer has exceeded spending limit. ".concat(velocitySpendLimitsLink),
            },
        ],
        [
            'V007',
            {
                source: constants_1.SOURCES.TRANSACTION_VELOCITY_CHECK,
                ecomm: "Customer has exceeded transaction limit. ".concat(velocityTransactionLimitsLink),
                pos: "Customer has exceeded transaction limit. ".concat(velocityTransactionLimitsLink),
            },
        ],
        [
            'V008',
            {
                source: constants_1.SOURCES.CONSUMER_VELOCITY_CHECK,
                ecomm: "Customer has exceeded spending limit. ".concat(velocitySpendLimitsLink),
                pos: "Customer has exceeded spending limit. ".concat(velocitySpendLimitsLink),
            },
        ],
        [
            'V010',
            {
                source: constants_1.SOURCES.TRANSACTION_VELOCITY_CHECK,
                ecomm: "Customer has exceeded spending limit. ".concat(velocitySpendLimitsLink),
                pos: "Customer has exceeded spending limit. ".concat(velocitySpendLimitsLink),
            },
        ],
        [
            'V011',
            {
                source: constants_1.SOURCES.TRANSACTION_VELOCITY_CHECK,
                ecomm: "Customer has exceeded transaction limit. ".concat(velocityTransactionLimitsLink),
                pos: "Customer has exceeded transaction limit. ".concat(velocityTransactionLimitsLink),
            },
        ],
        [
            'V012',
            {
                source: constants_1.SOURCES.TRANSACTION_VELOCITY_CHECK,
                ecomm: "Customer has exceeded transaction limit. ".concat(velocityTransactionLimitsLink),
                pos: "Customer has exceeded transaction limit. ".concat(velocityTransactionLimitsLink),
            },
        ],
        [
            'V013',
            {
                source: constants_1.SOURCES.TRANSACTION_VELOCITY_CHECK,
                ecomm: "Customer has exceeded transaction limit. ".concat(velocityTransactionLimitsLink),
                pos: "Customer has exceeded transaction limit. ".concat(velocityTransactionLimitsLink),
            },
        ],
        [
            'V014',
            {
                source: constants_1.SOURCES.TRANSACTION_VELOCITY_CHECK,
                ecomm: "Customer has exceeded transaction limit. ".concat(velocityTransactionLimitsLink),
                pos: "Customer has exceeded transaction limit. ".concat(velocityTransactionLimitsLink),
            },
        ],
        [
            'V015',
            {
                source: constants_1.SOURCES.TRANSACTION_VELOCITY_CHECK,
                ecomm: "Customer has exceeded transaction limit. ".concat(velocityTransactionLimitsLink),
                pos: "Customer has exceeded transaction limit. ".concat(velocityTransactionLimitsLink),
            },
        ],
        [
            'V016',
            {
                source: constants_1.SOURCES.SIFT,
                ecomm: "Customer has exceeded the $100 transaction limit. Please lower the order total and try again.",
                pos: "Customer has exceeded the $100 transaction limit. Please lower the order total and try again.",
            },
        ],
        [
            'V017',
            {
                source: constants_1.SOURCES.SIFT,
                ecomm: "Customer has exceeded $300 transaction limit. Please lower the order total and try again.",
                pos: "Customer has exceeded $300 transaction limit. Please lower the order total and try again.",
            },
        ],
        [
            'Y999',
            {
                source: constants_1.SOURCES.DUTCHIE_PAY,
                ecomm: (0, exports.getDefaultDutchiePayError)(name),
                pos: (0, exports.getDefaultDutchiePayError)(name),
            },
        ],
    ]);
};
exports.dutchiePayErrors = dutchiePayErrors;
function getDutchiePayErrorMessage(errCode, defaultMessage, name) {
    var defaultMsg = defaultMessage ? defaultMessage : (0, exports.getDefaultDutchiePayError)(name);
    return (0, get_message_1.getMessage)((0, exports.dutchiePayErrors)(name), defaultMsg, errCode);
}
exports.getDutchiePayErrorMessage = getDutchiePayErrorMessage;
exports.dutchiePayReasonCodes = Array.from((0, exports.dutchiePayErrors)().keys());
